import React from 'react';
import { Flex } from 'antd';
import { formatDate } from 'shared/utils/time/format-date';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import { ClientFinancialTag } from 'components/clients/client-financial-tag';
import { CardUi } from 'components/common/card-ui';
import { InfaktInvoiceLink } from 'components/invoices/infakt-invoice-link';
import { InfaktSyncTag } from 'components/invoices/infakt-sync-tag';
import type { IInvoiceInfoCardProps } from 'components/invoices/invoice-info-card/types';

export const InvoiceInfoCard: React.FC<IInvoiceInfoCardProps> = (props) => {
  const { invoice, client } = props;

  return (
    <CardUi>
      <Flex align='start' gap='small' vertical>
        <Flex align='center' gap='small'>
          <InfaktSyncTag status={invoice.infaktSync?.status} />
          <InfaktInvoiceLink infaktSync={invoice.infaktSync} />
        </Flex>
        <ClientFinancialTag
          paymentPeriod={invoice.order?.paymentPeriod}
          paymentTerms={invoice.order?.paymentTerms}
          clientPaymentTerms={client.paymentTerms}
          clientPaymentPeriod={client.paymentPeriod}
        />
        <div>
          <strong>Created:</strong> {formatDateTime(invoice.createdAt)}
        </div>
        <div>
          <strong>Service Date:</strong> {formatDate(invoice.serviceDate ?? invoice.createdAt)}
        </div>
        {invoice.issuedDate && (
          <div>
            <strong>Issued Date:</strong> {formatDate(invoice.issuedDate)}
          </div>
        )}
        <div>
          <strong>Manager:</strong> {invoice.user?.name}
        </div>
      </Flex>
    </CardUi>
  );
};
